/**
 * Code ambassadeur capturé via ?promo=CODE (checkout / signup).
 * Distinct de ?via= (Endorsely B2B).
 */
export const AMBASSADOR_PROMO_STORAGE_KEY = 'ambassador_promo';

const PROMO_CODE_RE = /^[A-Za-z0-9-]{4,64}$/;

export function capturePromoQueryParam(search: string): string | null {
  const rawSearch = search.startsWith('?') ? search.slice(1) : search;
  const params = new URLSearchParams(rawSearch);
  const raw = (params.get('promo') || '').trim();
  if (!PROMO_CODE_RE.test(raw)) return null;
  return raw.toUpperCase();
}

export function persistAmbassadorPromo(code: string): void {
  try {
    sessionStorage.setItem(AMBASSADOR_PROMO_STORAGE_KEY, code);
  } catch {
    // ignore quota / private mode
  }
}

export function readStoredAmbassadorPromo(): string | null {
  try {
    const stored = (sessionStorage.getItem(AMBASSADOR_PROMO_STORAGE_KEY) || '').trim();
    if (!PROMO_CODE_RE.test(stored)) return null;
    return stored.toUpperCase();
  } catch {
    return null;
  }
}

export function resolveAmbassadorPromoFromLocation(search: string): string | null {
  const fromUrl = capturePromoQueryParam(search);
  if (fromUrl) {
    persistAmbassadorPromo(fromUrl);
    return fromUrl;
  }
  return readStoredAmbassadorPromo();
}

export function ambassadorSharePath(code: string): string {
  return `/signup-professional?promo=${encodeURIComponent(code)}`;
}
